import { Toaster } from "sonner";

export function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        className:
          // 2026-05-24: 用 semantic token (跟全平台 design system 一致), 不再硬编 zinc-*
          "!bg-white !text-t0 !border-b1 dark:!bg-s1 dark:!text-t0 dark:!border-b0",
        duration: 4000,
      }}
      richColors
    />
  );
}
